// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBCBKXErexLN27hpM-mgF-Q6zPL13HSb6w",
  authDomain: "tributos-y-finanzas-7c1c9.firebaseapp.com",
  projectId: "tributos-y-finanzas-7c1c9",
  storageBucket: "tributos-y-finanzas-7c1c9.appspot.com",
  messagingSenderId: "689228571382",
  appId: "1:689228571382:web:5962cb9078010918a742d7"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
export default firebaseApp
